import { HttpContextToken } from '@angular/common/http';
import { InjectionToken, FactoryProvider } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window');

const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: () => window
};

export const WINDOW_PROVIDERS = [windowProvider];
export const SKIP_AB_TEST_HEADERS = new HttpContextToken<boolean>(() => false);
export const SKIP_SIMPLE_BOOKING_HEADERS = new HttpContextToken<boolean>(() => false);

